// extracted by css-extract-rspack-plugin
export default {"container":"s3qJhMzmvxwKfvRd__container___","section":"lZy08QLBVV8jaU82__section___","header":"O_qCxNFjj07Cx3Ev__header___","title":"Vbvtk7xpQEGKy9FW__title___"};